/**
 * Frontend JavaScript for the Number Counter block.
 * Animates numbers from start to end value when the block enters the viewport.
 */

/* global IntersectionObserver, requestAnimationFrame */

function easeInQuad(t) {
	return t * t;
}

function formatNumber(value, format, decimals) {
	if (format === 'none') {
		return decimals > 0
			? value.toFixed(decimals)
			: Math.round(value).toString();
	}

	const fixed =
		decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
	const parts = fixed.split('.');
	const integerPart = parts[0];
	const decimalPart = parts[1];

	let separator = '';
	let decimalSeparator = '.';

	switch (format) {
		case 'comma':
			separator = ',';
			decimalSeparator = '.';
			break;
		case 'period':
			separator = '.';
			decimalSeparator = ',';
			break;
		case 'space':
			separator = ' ';
			decimalSeparator = '.';
			break;
		default:
			separator = '';
			decimalSeparator = '.';
	}

	const formattedInteger = integerPart.replace(
		/\B(?=(\d{3})+(?!\d))/g,
		separator
	);

	return decimalPart
		? `${formattedInteger}${decimalSeparator}${decimalPart}`
		: formattedInteger;
}

function animateNumber(element, start, end, duration, format, decimals) {
	const startTime = performance.now();
	const difference = end - start;

	function update(currentTime) {
		const elapsed = currentTime - startTime;
		const progress = Math.min(elapsed / duration, 1);
		const easedProgress = easeInQuad(progress);

		const currentValue = start + difference * easedProgress;

		element.textContent = formatNumber(currentValue, format, decimals);

		if (progress < 1) {
			requestAnimationFrame(update);
		} else {
			element.textContent = formatNumber(end, format, decimals);
		}
	}

	requestAnimationFrame(update);
}

function initCounter(block) {
	const valueElement = block.querySelector('.number-counter-value');
	if (!valueElement) {
		return;
	}

	const start = parseFloat(block.dataset.start) || 0;
	const end = parseFloat(block.dataset.end) || 0;
	const duration = parseFloat(block.dataset.duration) || 2000;
	const format = block.dataset.format || 'none';
	const decimals = parseInt(block.dataset.decimals) || 0;

	valueElement.textContent = formatNumber(start, format, decimals);

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Wait 1 second before starting the animation.
					setTimeout(() => {
						animateNumber(
							valueElement,
							start,
							end,
							duration,
							format,
							decimals
						);
					}, 300);
					observer.unobserve(entry.target);
				}
			});
		},
		{
			threshold: 0.1,
		}
	);

	observer.observe(block);
}

function initAllCounters() {
	const blocks = document.querySelectorAll('.wp-block-diakon-number-counter');
	blocks.forEach(initCounter);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initAllCounters);
} else {
	initAllCounters();
}
